<template>
  <div
    class='theme-select'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--is-disabled': disabled,
      'theme-input__field-holder--is-dirty': isDirty,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label class='theme-input__label' v-if='showLabel && labelHtml' v-html='labelHtml'></label>
    <label class='theme-input__label' v-else-if='showLabel && label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <div class='theme-select__wrapper'>
      <select
        :class="['theme-input theme-input--select',
        {
          'theme-input--select-extra': isExtraInfo,
        }]"
        :style="{ color: model ? 'black' : 'grey' }"
        v-model='model'
        type='text'
        :name='name'
        :disabled='disabled'
        @change="$emit('input', model); $emit('change', model)"
      >
        <option v-if='placeholder' disabled value="">{{placeholder}}</option>
        <option
          v-if='zeroOption && showZeroOption == 1'
          key='zero-option'
          value='0'
        >
          {{ zeroOption }}
        </option>
        <option
          v-else-if='showZeroOption == 1'
          key='zero-option'
          :value='``'
        ></option>
        <option
          v-for='(option, key) in options'
          :key='`${key}-option`'
          :value='key'
        >
          {{ option }}
        </option>
      </select>
      <div class='theme-input__extra-info' v-if='isExtraInfo'>
        <slot name='extra-info'></slot>
      </div>
      <span v-if='errors.has(newName)' class='icon-warning theme-input__icon theme-input__icon-error right-9'/>
    </div>
    <div class='theme-input__error-text' v-if='errors.has(newName) && showErrorMessage'>
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../admin/mixins/field';

  export default {
    computed: {
      isDirty() {
        return this.model !== null;
      },
    },
    mixins: [field],
    props: {
      options: {
        default: () => {
          return {};
        },
        type: [Object, Array],
      },
      labelHtml: {
        default() {
          return '';
        },
        type: String,
      },
      zeroOption: {
        default() {
          return '';
        },
        type: String,
      },
      showZeroOption: {
        default() {
          return '1';
        },
        type: String,
      },
      showLabel: {
        default: true,
        type: Boolean,
      },
      isExtraInfo: {
        default: false,
        type: Boolean,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
      placeholder: {
        default: '',
        type: String,
      },
      disabled: {
        default: false,
        type: Boolean,
      },
      showErrorMessage: {
        default: true,
        type: Boolean,
      },
    },
    watch: {
      errors: function(value) {},
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/ThemeSelect.vue